import { render, staticRenderFns } from "./Sizecss.vue?vue&type=template&id=311f574c&scoped=true"
import script from "./Sizecss.vue?vue&type=script&lang=js"
export * from "./Sizecss.vue?vue&type=script&lang=js"
import style0 from "./Sizecss.vue?vue&type=style&index=0&id=311f574c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311f574c",
  null
  
)

export default component.exports